import { gql } from '@apollo/client';

import Entity from '../entity';

/** The transaction an alert is about, as the alert's own surfaces render it. */
export const AlertTransactionFragment = gql`
  fragment AlertTransaction on Transaction {
    id
    amount
    date
    description
    merchant {
      id
      name
      logoUrl
    }
    financialAccount {
      id
      name
      mask
      subtype
      ...EntityAvatar
      bank {
        id
        name
      }
    }
  }
  ${Entity.Avatar.Fragment}
`;
